import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { MachineGroupSectionBuilder } from '../../models/builders/machine-group-section.builder';
import { MachineGroupSection } from '../../models/machine-group-section';
import { Model } from '../../models/model';
import { mapCollection } from '../../utils/collection.utils';

const sectionBody = (section: MachineGroupSection) => ({
  name: section.name,
  modelHashes: mapCollection((model: Model) => model.hash, section.models)
});

@Injectable()
export class MachineGroupSectionApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }working-model-groups`;
  }

  createSection(machineGroupHash: string, section: MachineGroupSection) {
    return this.httpClient.post(`${ this.apiUrl }/${ machineGroupHash }/sections`, sectionBody(section))
      .pipe(
        map(MachineGroupSectionBuilder.fromJson)
      );
  }

  updateSection(machineGroupHash: string, section: MachineGroupSection) {
    return this.httpClient.put(`${ this.apiUrl }/${ machineGroupHash }/sections/${ section.hash }`, sectionBody(section))
      .pipe(
        map(MachineGroupSectionBuilder.fromJson)
      );
  }

  deleteSection(machineGroupHash: string, section: MachineGroupSection) {
    return this.httpClient.delete(`${ this.apiUrl }/${ machineGroupHash }/sections/${ section.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/machine-group-section-api.service.ts